import { render } from "./CustomResponse.vue?vue&type=template&id=313c16dc&scoped=true"
import script from "./CustomResponse.vue?vue&type=script&lang=js"
export * from "./CustomResponse.vue?vue&type=script&lang=js"

import "./CustomResponse.vue?vue&type=style&index=0&id=313c16dc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-313c16dc"]])

export default __exports__